module.exports = __webpack_public_path__ + "img/LOGO_Custom.a1ec5d06.png";